import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { compose } from "recompose";
import { FormattedMessage } from "react-intl";
import { Badge } from "reactstrap";

import { makeDemographicsGet } from "@api/index";
import { connectToApi } from "@api/components/connectToApi";
import { CardTitle } from "@ui/Page";
import { equalDateAndMoment } from "@util/index";
import {
    MusicIdProps,
    getDemographicsLastLoadedForProps,
    getDemographicsSetForProps,
    getSettingFrom,
    getSettingTo,
} from "../../selectors";
import { messages } from "../../messages";
import { SalesState } from "../../models";
import { AgeBarChart } from "../AgeBarChart";
import { GenderPieChart } from "../GenderPieChart";
import { RegionTable } from "../RegionTable";
import { InfoPopover } from "@app/modules/ui/InfoPopover";

type Props = MusicIdProps;

const DemographicsCharts = (props: Props) => {
    return (
        <div className="demographics-charts">
            <div className="demographics-charts__gender">
                <div className="demographics-charts__gender__title">
                    <h4 className="display-4 d-inline-block">
                        <FormattedMessage {...messages.genderTitle} />
                    </h4>
                    <InfoPopover
                        id="demographics-gender-popover"
                        bodyMessage={messages.genderSmallprint}
                    />
                </div>
                <GenderPieChart {...props} />
            </div>
            <div className="demographics-charts__age">
                <div className="demographics-charts__age__title">
                    <h4 className="display-4 d-inline-block">
                        <FormattedMessage {...messages.ageTitle} />
                    </h4>
                    &nbsp;
                    <Badge className="text-dark" color="light">Spotify</Badge>
                </div>
                <AgeBarChart {...props} vendor="spotify" />
            </div>
            <div className="demographics-charts__age">
                <div className="demographics-charts__age__title">
                    <h4 className="display-4 d-inline-block">
                        <FormattedMessage {...messages.ageTitle} />
                    </h4>
                    &nbsp;
                    <Badge  className="text-dark" color="light">Apple Music</Badge>
                </div>
                <AgeBarChart {...props} vendor="apple" download={false} />
            </div>
            <div className="demographics-charts__region">
                <h4 className="display-3 d-inline-block">
                    <FormattedMessage {...messages.regionTitle} />
                </h4>
                &nbsp;
                <Badge className="text-dark" color="light">Spotify</Badge>
                <RegionTable {...props} vendor="spotify" />
            </div>
        </div>
    );
};

const mapStateToProps = (state: SalesState, props: MusicIdProps) => {
    const from = getSettingFrom(state);
    const to = getSettingTo(state);
    const actionCreators = [ makeDemographicsGet(
        props.albumId,
        props.trackId,
        props.artistId,
        from,
        to,
    ) ];
    const requestId = [ from.format() + "_" + to.format() ];
    const set = getDemographicsSetForProps(state, props);
    let lastLoaded = getDemographicsLastLoadedForProps(state, props);
    // If the settings dates are different to the loaded set, load again
    if (lastLoaded != null && set != null &&
        (!equalDateAndMoment(set.from, from) || !equalDateAndMoment(set.to, to))
    ) {
        lastLoaded = null;
    }
    return {
        // API options
        actionCreators,
        requestId,
        lastLoaded: [ lastLoaded ],
    };
};

const ConnectedDemographicsCharts = compose<Props, MusicIdProps>(
    connect(mapStateToProps, null),
    connectToApi({}),
)(DemographicsCharts);

export {
    DemographicsCharts as DemographicsChartsPresenter,
    ConnectedDemographicsCharts as DemographicsCharts,
};
